"use client"
import "./Footer.css"
import logo from "../../Images/Great-Place-To-Work-LOGO-01-24-25.png"
import footerArrowIcon from "../../Images/footer-arrow-icon.png"
import twitterIcon from "../../Images/icons8-twitterx-50.png"
import googlePlayIcon from "../../Images/google-play-icon.png"
import appStoreIcon from "../../Images/app-store-icon.png"

import "font-awesome/css/font-awesome.min.css"

const Footer = () => {
  return (
    <footer className="ari-footer">
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <div className="ari-footer-menu clearfix">
              <div className="ari-footer-menu-inner ari-footer-menu-inner-1">
                <h3>Product</h3>
                <ul>
                  <li>
                    <a href="/equity-trading-account">Equity</a>
                  </li>
                  <li>
                    <a href="/invest-in-mutual-funds">Mutual Funds</a>
                  </li>
                  <li>
                    <a href="/national-pension-scheme-nps">NPS</a>
                  </li>
                  <li>
                    <a href="/fixed-income">Fixed Income</a>
                  </li>
                  <li>
                    <img
                      src={logo || "/placeholder.svg"}
                      alt="Great Place To Work Logo"
                      className="img-responsive"
                      style={{ maxWidth: "100%", height: "auto", marginLeft: "20px" }}
                    />
                  </li>
                </ul>
              </div>

              <div className="ari-footer-menu-inner ari-footer-menu-inner-2">
                <h3>Trading</h3>
                <ul>
                  <li>
                    <a href="/online-trading-platform">Trading Platforms</a>
                  </li>
                  <li>
                    <a
                      href="https://www.arihantcapital.com/margin-calculator"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Margin Calculator
                    </a>
                  </li>
                </ul>
                <br />
                <h3>Useful Links</h3>
                <ul>
                  <li>
                    <a
                      href="https://evoting.cdslindia.com/Evoting/EvotingLogin"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      CDSL eVoting
                    </a>
                  </li>
                  <li>
                    <a href="https://www.evoting.nsdl.com/" target="_blank" rel="noopener noreferrer">
                      NSDL eVoting
                    </a>
                  </li>
                  <li className="menu-hide-767 ari-quick-links">
                    <a href="/ReferAndEarn/index.html" target="_blank" rel="noopener noreferrer">
                      Refer &amp; Earn
                    </a>
                  </li>
                </ul>
              </div>

              <div className="ari-footer-menu-inner ari-footer-menu-inner-3">
                <h3>Who We Are</h3>
                <ul>
                  <li>
                    <a href="/about-us">About Us</a>
                  </li>
                  <li>
                    <a href="/investor-relations">Investor Relations</a>
                  </li>
                  <li>
                    <a href="/careers">Work at Arihant</a>
                  </li>
                  <li>
                    <a
                      href="https://www.arihantcapital.com/institutional-broking"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Institutional Equities
                    </a>
                  </li>
                  <li>
                    <a href="https://www.arihantcapital.com/merchant-banking" target="_blank" rel="noopener noreferrer">
                      Merchant Banking
                    </a>
                  </li>
                  <li>
                    <button className="tooltip" onClick={() => alert("Coming Soon")}>
                      Corporate Desk <span className="tooltiptext">Coming Soon</span>
                    </button>
                  </li>
                </ul>
              </div>

              <div className="ari-footer-menu-inner ari-footer-menu-inner-4">
                <h3>Connect With Us</h3>
                <ul>
                  <li>
                    <a href="https://ekyc.arihantcapital.com/" target="_blank" rel="noopener noreferrer">
                      Open an Account
                    </a>
                  </li>
                  <li>
                    <a href="/invester-charter">Investor Charter</a>
                  </li>
                  <li>
                    <a href="/contact-us">Contact Us</a>
                  </li>
                  <li>
                    <a href="https://support.arihantcapital.com/support/home" target="_blank" rel="noopener noreferrer">
                      Support
                    </a>
                  </li>
                  <li>
                    <a href="/business-partner">Partner With Us</a>
                  </li>
                </ul>
              </div>

              <div className="ari-footer-menu-inner ari-footer-menu-inner-5">
                <h3 style={{ textAlign: "left" }}>Follow Us</h3>
                <div className="ari-footer-input">
                  <input type="email" id="footer_email" placeholder="Email" />
                  <span>
                   <a href="https://www.arihantcapital.com/">
    <img
      src={footerArrowIcon || "/placeholder.svg"}
      alt="footer-arrow-icon"
      className="img-responsive footer-arrow"
      style={{ cursor: "pointer" }}
    />
  </a>
                  </span>
                </div>

                <div className="ari-footer-social-icons">
                  <ul>
                    <li>
                      <a href="https://twitter.com/ArihantPlus" target="_blank" rel="noopener noreferrer">
                        <img
                          src={twitterIcon || "/placeholder.svg"}
                          alt="Twitter icon"
                          className="tweet"
                          style={{ height: "26px", width: "26px" , marginTop: "-6px"}}
                        />
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://www.facebook.com/arihantcapitalmarkets"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <i className="fa fa-facebook" aria-hidden="true"></i>
                      </a>
                    </li>
                    <li>
                      <a href="https://www.instagram.com/arihant_plus" target="_blank" rel="noopener noreferrer">
                        <i className="fa fa-instagram" aria-hidden="true"></i>
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://www.linkedin.com/company/arihant-capital-markets-ltd/mycompany/"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <i className="fa fa-linkedin" aria-hidden="true"></i>
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://www.youtube.com/channel/UCrPcG3wkHygflvEIMcb_I3Q"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <i className="fa fa-youtube" aria-hidden="true"></i>
                      </a>
                    </li>
                    <li>
                      <a href="http://wa.me/917314217003/?text=Hello" target="_blank" rel="noopener noreferrer">
                        <i className="fa fa-whatsapp" aria-hidden="true"></i>
                      </a>
                    </li>
                  </ul>
                </div>
                <div className="ari-footer-app">
                  <span>
                    <a
                      href="https://play.google.com/store/apps/details?id=com.msf.acml&gl=us"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img
                        src={googlePlayIcon || "/placeholder.svg"}
                        alt="Google Play Store"
                        className="img-responsive"
                        style={{ height: "40px", width: "auto" }}
                      />
                    </a>
                  </span>
                  <span>
                    <a
                      href="https://apps.apple.com/in/app/arihant-plus/id1643484698"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img
                        src={appStoreIcon || "/placeholder.svg"}
                        alt="App Store"
                        className="img-responsive"
                        style={{ height: "40px", width: "auto" }}
                      />
                    </a>
                  </span>
                </div>
              </div>
            </div>

            <hr className="ari-footer-hr" />
            <div className="ari-footer-inv-alert"></div>
            <div className="ari-footer-attention-inv" style={{ textAlign: "left", margin: "0 1rem" }}>
              <p>
                Arihant Capital Markets Limited is a SEBI registered stock broker and depository participant. SEBI
                Registration number for NSE &amp; BSE: INZ000180939; NSDL - IN-DP-127-2015 DP ID-IN301983; CDSL DP
                ID-43000; NCDEX - 01274; MCX - 56565; AMFI - ARN 15114; AMFI-registered Mutual Fund Distributor; ARN
                registration year - 2004; ARN validity up to- 18/12/2025; SEBI Merchant Banking Reg. No. - MB
                INM000011070; SEBI Research Analyst Reg. No. - INH000002764. <b>Registered Address:</b> 6, Lad colony,
                Y.N. Road, Indore – 452001. <b>Corporate office address:</b> #1011 Solitaire Corporate Park, Andheri
                Ghatkopar Link Road, Chakala, Andheri (E), Mumbai - 400093.
              </p>
              <p>
                Please carefully read the risk disclosure document as prescribed by SEBI, as well as the 'Do’s and
                Don’ts' provided by NSE, BSE, NCDEX, and MCX. If you have any complaints related to securities broking,
                kindly contact us at <a href="mailto:complaint@arihantcapital.com">complaint@arihantcapital.com</a>. For
                DP-related matters, please reach out to us at{" "}
                <a href="mailto:depository@arihantcapital.com">depository@arihantcapital.com</a>.
              </p>
              <p>
                If you want to register your complaints through SEBI Score Portal please{" "}
                <a href="https://scores.sebi.gov.in" target="_blank" rel="noopener noreferrer">
                  click here
                </a>
                . Mandatory details for filing complaints on SCORES: Name, PAN, Address, Mobile Number, E-mail ID.
                Benefits: Effective Communication, Speedy redressal of the grievances.
              </p>
              <p>
                Investments in securities market are subject to market risks; read all the related documents carefully
                before investing.
              </p>
              <p>
                Disclaimer: Arihant Capital Markets Limited is engaged in client-based and proprietary trading on
                various exchanges.
              </p>
              <ul
                type="bullets"
                style={{
                  fontSize: "16px",
                  color: "black",
                  fontFamily: "Futura PT Book",
                  fontWeight: 400,
                  fontStyle: "normal",
                  margin: "2rem 0",
                }}
              >
                <p
                  style={{
                    color: "black",
                    fontWeight: "900",
                  }}
                >
                  ATTENTION INVESTORS:
                </p>
                <li>
                  KYC is one time exercise while dealing in securities markets - once KYC is done through a SEBI
                  registered intermediary (Broker, DP, Mutual Fund etc.), you need not undergo the same process again
                  when you approach another intermediary.
                </li>
                <li>
                  For Stock Broking Transaction 'Prevent unauthorized transactions in your account - update your mobile
                  numbers/email IDs with your stockbrokers. Receive information of your transactions directly from
                  Exchange on your mobile/email at the end of the day.
                </li>
                <li>
                  For Depository Transaction 'Prevent Unauthorized Transactions in your demat account - Update your
                  Mobile Number with your Depository Participant. Receive alerts on your Registered Mobile for all debit
                  and other important transactions in your demat account directly from CDSL/NSDL on the same day.
                </li>
                <li>
                  If you are subscribing to an IPO, there is no need to issue cheques. Just write the bank account
                  number and sign in the application form to authorize your bank to make payment in case of allotment.
                  No worries for refund as the money remains in investor's account.
                </li>
                <li>
                  Investors should be cautious on unsolicited emails and SMS advising to buy, sell or hold securities
                  and trade only on the basis of informed decision. Investors are advised to invest after conducting
                  appropriate analysis of respective companies and not to blindly follow unfounded rumors, tips etc.
                  Further, you are also requested to share your knowledge or evidence of systemic wrongdoing, potential
                  frauds or unethical behaviour through the anonymous portal facility provided on BSE &amp; NSE website.
                </li>
                <li>
                  Registration granted by SEBI and certification from NISM in no way guarantee performance of the
                  intermediary or provide any assurance of returns to investors.
                </li>
                <li>
                  Pay 20% or "var + elm" whichever is higher as upfront margin of the transaction value to trade in cash
                  market segment.
                </li>
                <li>
                  Investors may please refer to the Exchange's Frequently Asked Questions (FAQs) issued vide circular
                  reference NSE/INSP/45191 dated July 31, 2020 and NSE/INSP/45534 dated August 31, 2020 and other
                  guidelines issued from time to time in this regard.
                </li>
              </ul>
              <p>
                <b>Awareness regarding guidelines of margin collection:</b>
                <br />
                1) Stock brokers can accept securities as margins from clients only by way of pledge in the depository
                system w.e.f September 01, 2020.
                <br />
                2) Update your e-mail and phone number with your stock broker/depository participant and receive OTP
                directly from depository on your e-mail and/or mobile number to create pledge.
                <br />
                3) Check your securities/MF/bonds in the consolidated account statement issued by NSDL/CDSL every month.
                <br />
                Issued in the interest of investors
              </p>
            </div>
            <div
              className="col-md-12 no-pad pad-20"
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                flexWrap: "wrap",
                paddingBottom: "20px",
              }}
            >
              <div style={{ display: "flex", alignItems: "center", flexWrap: "wrap" }}>
                <p className="wht-clr" style={{ margin: 0 }}>
                  Copyright © 2024 Arihant Capital Markets Ltd. All rights Reserved.
                </p>
                <div
                  className="footer-links"
                  style={{ display: "flex", alignItems: "center", marginLeft: "20px", flexWrap: "wrap" }}
                >
                  <a href="https://www.arihantcapital.com/privacyandsecurity" className="footer-link">
                    Privacy
                  </a>
                  <span style={{ margin: "0 5px" }}>|</span>
                  <a href="https://www.arihantcapital.com/termsandconditions" className="footer-link">
                    Terms and Conditions
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
